import { useMediaQuery, useTheme } from '@material-ui/core'

export const useIsMobile = () => {
  const theme = useTheme()

  const xs = useMediaQuery(theme.breakpoints.only('xs'))
  const sm = useMediaQuery(theme.breakpoints.only('sm'))
  return xs || sm
}
